import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavUtils } from "../../../utils";
import { CustomButton } from "../../../../common/components";
import KeycloakService from "../../../../services/KeycloakService";
import permissions from "../../../../common/providers/permissions/permissions";
import { getWhiteLabelConfig } from "../../../../common/config";

const { logo, croppedLogo, altText } = getWhiteLabelConfig();

export default function ImageButton() {
	const [currentLogo, setCurrentLogo] = useState(window.innerWidth > 1400 ? logo : croppedLogo);
	const navigate = useNavigate();
	useEffect(() => {
		const handleLogoSize = () => {
			setCurrentLogo(window.innerWidth > 1400 ? logo : croppedLogo);
		};
		window.addEventListener("resize", handleLogoSize);
		return () => window.removeEventListener("resize", handleLogoSize);
	}, []);
	return (
		<CustomButton
			data-testid="home.icon"
			onClick={() => {
				navigate(
					(KeycloakService.hasRole([permissions.REALM.ADMIN.claim]) && NavUtils.goToDSI()) ||
						NavUtils.goToHome()
				);
			}}
		>
			<img alt={altText} height="16" src={currentLogo} />
		</CustomButton>
	);
}
